import { render, staticRenderFns } from "./PidReportForm.vue?vue&type=template&id=b38e7a50&scoped=true&"
import script from "./PidReportForm.vue?vue&type=script&lang=js&"
export * from "./PidReportForm.vue?vue&type=script&lang=js&"
import style0 from "./PidReportForm.vue?vue&type=style&index=0&id=b38e7a50&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38e7a50",
  null
  
)

export default component.exports